import { useCallback, useState } from "react";
import { Input, message, Space } from "antd";
import { serverFetch } from "@/server";
import { ScanButton } from "@/extensions/design";
import { Scan } from "@/controls";

const VisitCardSelect = ({ value, onChange, onCardData, disabled }) => {
  const [loading, setLoading] = useState(false);

  const applyCode = useCallback(scannedCode => {
    const code = scannedCode?.trim();
    if (!code) {
      onChange?.(null);
      return;
    }

    setLoading(true);
    serverFetch("Card/byCode", { queryParams: { code } })
      .then(card => {
        setLoading(false);
        onChange?.(card.code ?? card.Code);
        onCardData?.(card);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }, [onChange, onCardData]);

  const scanDisabled = disabled || loading;

  return <Space.Compact style={{ width: "100%" }}>
    <Input
      value={value ?? ""}
      disabled
      placeholder="Считайте доп. карту"
    />
    <ScanButton title="Считайте доп. карту" onScan={applyCode} disabled={scanDisabled} />
    {!scanDisabled && <Scan onScan={applyCode} />}
  </Space.Compact>;
};

export default VisitCardSelect;
